<script setup>
/** ScheduleCampaignPage.vue - WhatsApp App (Baileys) */
import { columns } from './columns';
import DataTable from 'dashboard/routes/dashboard/campaigns/pages/whatsapp_oficial/components/table/DataTable.vue';
import { computed, onActivated } from 'vue';
import { useStore } from 'vuex';
import { flattenCampaigns } from 'dashboard/routes/dashboard/campaigns/pages/whatsapp_oficial/components/table/flattenCampaigns';
import whatsappIcon from 'dashboard/assets/images/whatsapp.png';

// Acessa o Vuex store
const store = useStore();

// Computa os dados das campanhas a partir do getter do store
const campaigns = computed(() => store.getters['campaigns/getAllCampaigns']);

// Filtra campanhas do WhatsApp App: apenas campaign_type === 'whatsapp_bayles'
const apiCampaigns = computed(() => {
  const all = campaigns.value || [];
  return all.filter(campaign => campaign.campaign_type === 'whatsapp_bayles');
});

// Se ainda quiser aplicar o flatten
const flatCampaigns = computed(() => flattenCampaigns(apiCampaigns.value));

onActivated(() => {
  store.dispatch('campaigns/get', { include_schedules: true });
});
</script>

<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<template>
  <div class="campaigns-page">
    <!-- WhatsApp Header -->
    <header class="whatsapp-header">
      <div class="header-background">
        <div class="header-content">
          <div class="header-info">
            <div class="header-icon">
              <img
                :src="whatsappIcon"
                alt="WhatsApp Business"
                class="whatsapp-icon"
              />
            </div>
            <div class="header-text">
              <h1 class="header-title">Campanhas WhatsApp</h1>
              <p class="header-description">
                Gerencie e monitore suas campanhas WhatsApp Business
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="page-content">
      <DataTable :data="flatCampaigns" :columns="columns" />
    </main>
  </div>
</template>

<style scoped>
.campaigns-page {
  @apply bg-n-background min-h-screen;
}

/* WhatsApp Header */
.whatsapp-header {
  @apply relative overflow-hidden;
}

.header-background {
  @apply bg-green-900/95;
}

.header-background::before {
  content: '';
  @apply absolute inset-0 opacity-30;
}

.header-content {
  @apply mx-auto px-4 py-4 flex items-center justify-between;
}

.header-info {
  @apply flex items-center gap-4;
}

.whatsapp-icon {
  @apply w-10 h-10 object-contain drop-shadow-sm;
}

.header-text {
  @apply flex flex-col gap-2;
}

.header-title {
  @apply text-3xl font-bold text-white m-0;
}

.header-description {
  @apply text-green-100 dark:text-green-200 max-w-2xl m-0 text-lg;
}

/* Main Content */
.page-content {
  @apply py-1;
}

/*
.table-wrapper {
  @apply bg-white dark:bg-n-slate-2 shadow-sm border border-green-100 dark:border-green-800 overflow-hidden;
}
*/

/* Status badges */
:deep(.status-badge) {
  @apply inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold;
}

:deep(.status-active) {
  @apply bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300;
}

:deep(.status-paused) {
  @apply bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300;
}

:deep(.status-completed) {
  @apply bg-woot-100 text-woot-800 dark:bg-woot-900/30 dark:text-woot-300;
}

:deep(.status-draft) {
  @apply bg-n-slate-3 text-n-slate-11 dark:bg-n-slate-4 dark:text-n-slate-10;
}

/* Action buttons */
:deep(.action-button) {
  @apply inline-flex items-center gap-1 px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200;
}

:deep(.action-button-primary) {
  @apply bg-green-600 hover:bg-green-700 text-white;
}

:deep(.action-button-secondary) {
  @apply bg-n-slate-3 hover:bg-n-slate-4 text-n-slate-11 dark:bg-n-slate-4 dark:hover:bg-n-slate-5 dark:text-n-slate-10;
}

:deep(.action-button-danger) {
  @apply bg-red-50 hover:bg-red-100 text-red-600 border border-red-200 dark:bg-red-900/20 dark:hover:bg-red-900/30 dark:text-red-400 dark:border-red-800;
}

/* Responsive */
@media (max-width: 768px) {
  .header-content {
    @apply flex-col gap-4 text-center;
  }

  .whatsapp-icon {
    @apply w-8 h-8;
  }

  .header-title {
    @apply text-2xl;
  }
}
</style>
